import { MouseEvent, ReactNode, useEffect, useRef } from "react";

import { OverlayContextProvider } from "@/components/General/Overlay/context/overlay.context";
import { useScrollLock } from "@/utils/hooks/useScrollLock";

const OVERLAY_SCROLL_LOCK = "overlay";

type Props = {
    open: boolean;
    overlayHeader?: boolean;
    scrollLock?: boolean;
    onClose: (event: MouseEvent<HTMLDivElement>) => void;
    children?: ReactNode;
};

export const Base = ({
    open,
    overlayHeader,
    scrollLock,
    onClose,
    children
}: Props) => {
    const mountElementRef = useRef<HTMLDivElement | null>(null);

    const { lock, unlock } = useScrollLock(OVERLAY_SCROLL_LOCK);

    useEffect(() => {
        if (!scrollLock) return;

        (open ? lock : unlock)();

        return () => {
            if (scrollLock) {
                unlock();
            }
        };
    }, [open, scrollLock, lock, unlock]);

    return (
        <div ref={mountElementRef}>
            <OverlayContextProvider
                open={open}
                overlayHeader={overlayHeader}
                scrollLock={scrollLock}
                mountElementRef={mountElementRef}
                onClose={onClose}
            >
                {children}
            </OverlayContextProvider>
        </div>
    );
};
